import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationChannels } from '@fitness-force/enum';
import { AppErrors, NotFoundError, ConflictError } from '@fitness-force/errors';
import { SubscriptionPlan, UpdatePlanStatusRequest, voidSubscriptionRequest } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  constructor(private http: HttpClient, private router: Router) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };



  createSubscriptionPlan(
    tenantId: number,
    createSubscriptionPlanRequest: SubscriptionPlan
  ) {
    return this.http
      .post(
        `${environment.BASE_URL}/tenants/${tenantId}/subscription_plans`,
        createSubscriptionPlanRequest,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateSubscriptionPlan(
    tenantId: number,
    sub_plan_od: number,
    updateSubscriptionPlanRequest: SubscriptionPlan
  ) {
    return this.http
      .put(
        `${environment.BASE_URL}/tenants/${tenantId}/subscription_plans/${sub_plan_od}`,
        updateSubscriptionPlanRequest,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSingleSubscriptionPlan(tenantId: number, sub_plan_id: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/subscription_plans/${sub_plan_id}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSubscriptionPlans(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams()
    if (allParams.length > 0) {

      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/subscription_plans`,
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  getSubscriptionPlansAll(tenantId: number) {

    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/subscription_plans`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



  markActive(tenantId: number, request: UpdatePlanStatusRequest) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/subscription_plans/mark_as_active`, request, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(tenantId: number, request: UpdatePlanStatusRequest) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/subscription_plans/mark_as_inactive`, request, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSubscriptionPlanClients(tenantId: number, sub_plan_id: number, allParams: Array<string> = []) {

    let parsedParams = new HttpParams()
    if (allParams.length > 0) {

      allParams.forEach((p: any) => {

        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/subscription_plans/${sub_plan_id}/clients`,
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  resendPaymentLink(tenantId: number, clientId: number, signupUuid: string, channel: any[]) {
    return this.http.post(`${environment.BASE_URL}/subscription/signup/${signupUuid}/tenants/${tenantId}/clients/${clientId}/send_payment_link`, channel
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  VoidSubscription(tenantId: number, clientId: number, subscriptionId: number, voidRequest: voidSubscriptionRequest) {
    return this.http.post(`${environment.BASE_URL}/tenant/${tenantId}/clients/${clientId}/subscriptions/${subscriptionId}/void`, voidRequest, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  VoidSignUp(tenantId: number, clientId: number, signUpId: number, request: any) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/subscription_signups/${signUpId}/void`, request, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  VoidUpgradeSubscription(tenantId: number, clientId: number, subscriptionId: number, voidRequest: voidSubscriptionRequest) {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/subscriptions/${subscriptionId}/voidupgrade`;
    return this.http.post(url, voidRequest, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ClientSubscriptionSendManageLink(tenant_id: number, clientId: number, subscriptionId: number, channels: NotificationChannels[]) {
    return this.http.post(`${environment.BASE_URL}/tenant/${tenant_id}/clients/${clientId}/subscriptions/${subscriptionId}/send_manage_link`
      , channels
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createBulkSubscriptionPlan(data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}/insert_enterprise_master`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getBulkSubscriptionPlans(allParams: Array<string> = []) {
    let parsedParams = new HttpParams()
    if (allParams.length > 0) {

      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http.get(`${environment.BASE_URL}/list_enterprise_master`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getBulkSubscriptionPlanById(subscriptionId: number) {
    return this.http.get(`${environment.BASE_URL}/${subscriptionId}/get_enterprise_master_by_id`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateBulkSubscriptionPlan(subscriptionId: number, data: any) {
    return this.http.put(`${environment.BASE_URL}/${subscriptionId}/update_enterprise_master`, data, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
